import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Swal from 'sweetalert2';
import Select from 'react-select';

const defaultCustomerData = {
    value: 0, 
    label: 'Seleccionar un cliente',
    document_type: '',
    document_type_id: 0
}

const ProjectMaster = () => {
  // Estados para el formulario
  const [formData, setFormData] = useState({
    codigo: '',
    nombreProyecto: '',
    cliente: '',
    activo: true
  });

  // Estado para la lista de proyectos
  const [projects, setProjects] = useState([]);
  
  // Estado para modo edición
  const [editingId, setEditingId] = useState(null);
  
  // Estado para validación
  const [errors, setErrors] = useState({});
  
  // Estado para modal
  const [showModal, setShowModal] = useState(false);

  // Lista de clientes (simulada - en producción vendría de una API)
  const [clientes, setClientes] = useState([]);

  const [cusOptionSelected,setCusOptionSelected] = useState(defaultCustomerData);

  const [loading, setLoading] = useState(false);

  const getCustomers = async() => {
    try {
      const resource = await axios.post(process.env.REACT_APP_PATH_API + 'get/customers'),
            data = await resource.data;
      setClientes(data)
    } catch ( err ) {
      console.log('Error charging customers', err)
    }
  }

  const getProjects = async() => {
    try {
      const resource = await axios.get(process.env.REACT_APP_PATH_API + 'get/projects'),
            data = await resource.data;
      setProjects(data)
    } catch ( err ) {
      console.log('Error charging projects', err)
    }
  }

  // Cargar datos iniciales (simulados)
  useEffect(() => {
    getProjects();
    getCustomers();
  }, []);

  // Manejar cambios en el formulario
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  // Validar formulario
  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.codigo.trim()) {
      newErrors.codigo = 'El código es requerido';
    } else if (formData.codigo.length < 3) {
      newErrors.codigo = 'El código debe tener al menos 3 caracteres';
    }
    
    if (!formData.nombreProyecto.trim()) {
      newErrors.nombreProyecto = 'El nombre del proyecto es requerido';
    }
    
    if (!formData.cliente||Number(formData.cliente)<=0) {
      newErrors.cliente = 'Debe seleccionar un cliente';
    }

    // Validar código único (solo al crear o si se cambió el código al editar)
    const existingProject = projects.find(p => 
      p.codigo === formData.codigo && p.id !== editingId
    );
    if (existingProject) {
      newErrors.codigo = 'Este código ya existe';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Resetear formulario
  const resetForm = () => {
    setFormData({
      codigo: '',
      nombreProyecto: '',
      cliente: '',
      activo: true
    });
    setEditingId(null);
    setErrors({});
    setCusOptionSelected(defaultCustomerData);
  };

  // Abrir modal para nuevo proyecto
  const handleNewProject = () => {
    resetForm();
    setShowModal(true);    
  };

  // Cerrar modal
  const handleCloseModal = () => {
    setShowModal(false);
    resetForm();
  };

  // Guardar o actualizar proyecto
  const handleSubmit = async(e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setLoading(true)
    try {

      const resource = await axios.post(process.env.REACT_APP_PATH_API + 'project/save', {
        id: editingId,
        token: localStorage.getItem('OSHEN-LOC-STR-TK'),
        parameters: formData
      }),
      data = await resource.data;
      console.log('data>>', data)
      if ( !data.status )
      {
        setLoading(false);
        Swal.fire({
            icon: 'warning',
            title: 'Advertencia',
            text: data.message
        })
        return
      }
      getProjects();
      setLoading(false);
      setShowModal(false);
      resetForm();
    } catch ( err ) {
      setLoading(false)
      console.log( 'Error con la creacion/actualizacion', err)
    }
  };

  // Editar proyecto
  const handleEdit = (project) => {
    setFormData({
      codigo: project.codigo,
      nombreProyecto: project.nombreProyecto,
      cliente: project.cliente,
      activo: project.activo
    });

    setCusOptionSelected({
      ...cusOptionSelected,
      value: project.cliente, 
      label: getClienteName(project.cliente)
    })
    setEditingId(project.id);
    setErrors({});
    setShowModal(true);
  };

  // Eliminar proyecto
  // const handleDelete = (id) => {
  //   if (window.confirm('¿Estás seguro de que deseas eliminar este proyecto?')) {
  //     setProjects(prev => prev.filter(project => project.id !== id));
  //     if (editingId === id) {
  //       resetForm();
  //     }
  //   }
  // };

  // Obtener nombre del cliente
  const getClienteName = (clienteId) => {
    const cliente = clientes.find(c => c.value === clienteId);
    return cliente ? cliente.label : clienteId;
  };

  return (
    <div className="container-fluid mt-4">
      {/* Header con título y botón nuevo */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-1">Gestión de Proyectos</h2>
          <p className="text-muted mb-0">Administra todos los proyectos de la empresa</p>
        </div>
        <button 
          className="btn btn-primary"
          onClick={handleNewProject}
        >
          <span className="me-2">+</span>
          Nuevo Proyecto
        </button>
      </div>
      
      {/* DataTable de proyectos */}
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <div className="d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Lista de Proyectos</h5>
            <span className="badge bg-secondary">
              Total: {projects.length} proyecto{projects.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
        <div className="card-body p-0">
          {projects.length === 0 ? (
            <div className="text-center py-5">
              <div className="mb-3">
                <i className="display-4 text-muted">📋</i>
              </div>
              <h5 className="text-muted">No hay proyectos registrados</h5>
              <p className="text-muted">Comienza creando tu primer proyecto</p>
              <button 
                className="btn btn-primary"
                onClick={handleNewProject}
              >
                Crear Primer Proyecto
              </button>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <thead className="table-light">
                  <tr>
                    <th scope="col" className="px-4 py-3">Código</th>
                    <th scope="col" className="py-3">Nombre del Proyecto</th>
                    <th scope="col" className="py-3">Cliente</th>
                    <th scope="col" className="py-3">Estado</th>
                    <th scope="col" className="py-3 text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {projects.map((project, ) => (
                    <tr key={project.id}>
                      <td className="px-4 py-3">
                        <span className="fw-bold text-primary">{project.codigo}</span>
                      </td>
                      <td className="py-3">
                        <div>
                          <div className="fw-semibold">{project.nombreProyecto}</div>
                        </div>
                      </td>
                      <td className="py-3">
                        <span className="text-dark">{getClienteName(project.cliente)}</span>
                      </td>
                      <td className="py-3">
                        <span className={`badge px-3 py-2 ${Number(project.activo) 
                          ? 'bg-success bg-opacity-10 text-success' 
                          : 'bg-secondary bg-opacity-10 text-secondary'}`}>
                          {Number(project.activo) ? '✓ Activo' : '✗ Inactivo'}
                        </span>
                      </td>
                      <td className="py-3 text-center">
                        <div className="btn-group" role="group">
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => handleEdit(project)}
                            title="Editar proyecto"
                          >
                            <i className="me-1">✏️</i>
                            Editar
                          </button>
                          {/* <button
                            type="button"
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleDelete(project.id)}
                            title="Eliminar proyecto"
                          >
                            <i className="me-1">🗑️</i>
                            Eliminar
                          </button> */}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          <button 
            className="btn btn-danger"
            style={{marginTop: 10, marginBottom: 10}}
            onClick={()=>location.href=process.env.REACT_APP_PATH_APP}
          >
            Regresar a la aplicación
          </button>
        </div>
      </div>

      <Modal size='lg' show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingId ? 'Editar Proyecto' : 'Nuevo Proyecto'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          
          <div onSubmit={handleSubmit}>

            <div className="row">

              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="codigo" className="form-label">
                    Código <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.codigo ? 'is-invalid' : ''}`}
                    id="codigo"
                    name="codigo"
                    value={formData.codigo}
                    onChange={handleInputChange}
                    placeholder="Ej: PRY001"
                  />
                  {errors.codigo && (
                    <div className="invalid-feedback">
                      {errors.codigo}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="mb-3">
                  <label htmlFor="nombreProyecto" className="form-label">
                    Nombre del Proyecto <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.nombreProyecto ? 'is-invalid' : ''}`}
                    id="nombreProyecto"
                    name="nombreProyecto"
                    value={formData.nombreProyecto}
                    onChange={handleInputChange}
                    placeholder="Nombre descriptivo del proyecto"
                  />
                  {errors.nombreProyecto && (
                    <div className="invalid-feedback">
                      {errors.nombreProyecto}
                    </div>
                  )}
                </div>
              </div>

            </div>
            
            <div className="row">

              <div className="col-md-6">
                <div className="mb-3 input-select-content">
                  <label htmlFor="cliente" className="form-label">
                    Cliente <span className="text-danger">*</span>
                  </label>
                  {/* <select
                    className={`form-select ${errors.cliente ? 'is-invalid' : ''}`}
                    id="cliente"
                    name="cliente"
                    value={formData.cliente}
                    onChange={handleInputChange}
                  >
                    <option value="">Seleccionar cliente...</option>
                    {clientes.map(cliente => (
                      <option key={cliente.id} value={cliente.id}>
                        {cliente.nombre}
                      </option>
                    ))}
                  </select> */}
                  <Select 
                    options={clientes} 
                    className="form-control" 
                    value={cusOptionSelected}
                    defaultValue={cusOptionSelected} 
                    onChange={(input)=>{
                        setCusOptionSelected(input)
                        setFormData({
                          ...formData,
                          cliente: input.value
                        })
                    }}
                  />
                  {errors.cliente && (
                    <div className="invalid-feedback">
                      {errors.cliente}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="col-md-6">
                <div className="mb-3">
                  <label className="form-label">Estado del Proyecto</label>
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="activo"
                      name="activo"
                      checked={Number(formData.activo)}
                      onChange={handleInputChange}
                    />
                    <label className="form-check-label" htmlFor="activo">
                      {formData.activo ? 'Proyecto activo' : 'Proyecto inactivo'}
                    </label>
                  </div>
                </div>
              </div>

            </div>

          </div>

        </Modal.Body>
        <Modal.Footer>
          <button 
            type="button" 
            className="btn btn-secondary"
            onClick={handleCloseModal}
          >
            Cancelar
          </button>
          <button 
            type="button" 
            className="btn btn-primary"
            onClick={handleSubmit}
            disabled={loading}
          >
            {editingId ? 'Actualizar' : 'Guardar'} Proyecto
          </button>
        </Modal.Footer>
      </Modal>
      
      {/* Información adicional */}
      <div className="mt-4">
        <div className="row">
          <div className="col-md-6">
            <small className="text-muted">
              * Campos obligatorios
            </small>
          </div>
          <div className="col-md-6 text-md-end">
            <small className="text-muted">
              Proyectos activos: {projects.filter(p => Number(p.activo)).length} | 
              Proyectos inactivos: {projects.filter(p => !Number(p.activo)).length}
            </small>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectMaster;